import { testWebP } from "../utils/utils";

export default class VimeoWrapper extends HTMLDivElement {
    connectedCallback() {

        if (this.style.backgroundImage?.trim() == "") {
            testWebP().then(hasWebP => {
                this.style.backgroundImage = `url("https://vumbnail.com/${this.dataset.videoId}.jpg")`;
            });
        }

        if (!this.playBtn) {
            const playBtn = document.createElement("button");
            playBtn.classList.add("video-wrapper-play-btn", "vimeo-wrapper-play-btn");
            this.append(playBtn);
        }

        if (!this.playBtn.getAttribute("aria-label")) {
            this.playBtn.setAttribute(
                "aria-label",
                this.dataset.playButtonText || "Spela video"
            );
        }

        this.playBtn.type = "button";

        this.addEventListener("click", this.loadVideo);
    }

    loadVideo = () => {
        const iframe = document.createElement("iframe");
        iframe.classList.add("video-wrapper-video", "vimeo-wrapper-video");
        iframe.title = this.dataset.videoTitle || "Vimeo video";
        iframe.width = 640;
        iframe.height = 360;
        iframe.allow = "autoplay; fullscreen; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.src = `https://player.vimeo.com/video/${this.dataset.videoId}?h=65e20fad6f&autoplay=1&title=0&byline=0&portrait=0`;
        this.append(iframe);

        this.playBtn?.remove();
        this.videoTitle?.remove();

        setTimeout(() => {
            iframe.contentWindow.focus();
        }, 500);
    };

    get playBtn() {
        return this.querySelector(".video-wrapper-play-btn");
    }

    get videoTitle() {
        return this.querySelector(".video-wrapper-title");
    }
}

customElements.define("vimeo-wrapper", VimeoWrapper, { extends: "div" });